import ReactDOM from 'react-dom'
import React, { useEffect, useState } from "react"
import * as nmapsgl from '@ndrive/nmaps-gl';
import '@ndrive/nmaps-gl/dist/nmaps-gl.css';
import './index.css'

const App = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    // Fetch runtime configuration
    fetch('/config.json')
      .then(response => response.json())
      .then(envConfig => {
        nmapsgl.baseApiUrl = envConfig.BASE_URL;
        nmapsgl.accessToken = envConfig.ACCESS_TOKEN;

        // map object
        const map = new nmapsgl.Map({
          container: "mapContainer",
          center: [-87.632367, 41.885135],
          zoom: 12,
          hash: true,
          attributionControl: false,
          canvasContextAttributes: {
            preserveDrawingBuffer: true
          },
          layerOptions: {
            //"nmapsgl_street_view": {
            //  mapillaryAccessToken: envConfig.MAPILLARY_ACCESS_TOKEN
            //},
            //"nmapsgl_opensky": {
            //  openSkyAuth: btoa(envConfig.OPENSKY_ACCESS_TOKEN)
            //},
            "nmapsgl_pois": {
              initialEnabled: true,
            }
          }
        });

        // Add controls
        map.addControl(new nmapsgl.NavigationControl(), 'top-right');
        map.addControl(new nmapsgl.GeolocateControl(), 'top-right');
        map.addControl(new nmapsgl.RotateControl(), 'top-right');
        map.addControl(new nmapsgl.RulerControl(), 'top-right');
        map.addControl(new nmapsgl.FullscreenControl(), 'top-right');
        map.addControl(new nmapsgl.TrafficControl({
          unit: 'Imperial'
        }), 'top-right');
        map.addControl(new nmapsgl.TrafficControl({
            unit: 'Metric'
        }), 'top-right');   
        map.addControl(new nmapsgl.TruckRestrictionsControl(), 'top-right');
        //map.addControl(new nmapsgl.StreetViewControl(), 'top-right');
        map.addControl(new nmapsgl.AttributionControl({ compact: false }), "bottom-right");
        map.addControl(new nmapsgl.StyleControl(), 'bottom-center');
        //map.addControl(new nmapsgl.LayersControl(), 'bottom-right');
        map.addControl(new nmapsgl.GeocoderControl(), 'top-center');
        map.addControl(new nmapsgl.DirectionsControl({
          // zoom: 14,
          flyTo: false,
          limit: 7,
          units: 'Imperial',
          profiles: {
              "Car": {
                  "mode": "fastest",
                  "transportation": "Car"
              },
              "Truck": {
                  "mode": "fastest",
                  "transportation": "Truck",
                  "truck_attributes": {
                      "weight": 36287.36,
                      "width": 2.4384,
                      "height": 4.1148,
                      "trailer_length": 14.6304,
                      "num_axles": 5,
                      "num_trailers": 1,
                      "hazmat": [
                          "None"
                      ]
                  }
              }
          },
          routingOptions: ['Tolls', 'Ferries', 'Freeways', 'Uturns', 'Small Roads', 'Country Crossing', 'Unpaved', 'Tunnels']
      }), 'top-left');
      });
  }, []);

  return (
    <>
      <div id="mapContainer" className="map"></div>
    </>
  );
}

ReactDOM.render(<App />, document.getElementById('app'));